<script>
import Layout from "../../layouts/main";
import UserEdit from "./user-edit";
import UserCharger from "./user-charger";
import UserVehicle from "./user-vehicle";
import UserBooking from "./user-booking.vue";
import UserWalletTransaction from "./user-wallet-transaction.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "user-details",
  data() {
    return {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        id: "",
        status: "",
        image: "",
      },
      full_name: "",
      isWalletHistory: String(this.$route.query.isWalletHistory) === "true",
    };
  },
  components: {
    Layout,
    UserEdit,
    UserCharger,
    UserVehicle,
    UserWalletTransaction,
    UserBooking,
  },
  computed: mapGetters("user", ["userData"]),
  methods: {
    ...mapActions("user", ["getUser", "updateUser"]),
    getUserDetail() {
      let id = this.$route.params.id;
      this.getUser({ id: id }).then((response) => {
        const { id, first_name, last_name, email, status } = response.data.result;
        this.profile_image_path = response.data.result.profile_image_path;
        this.profile_image = response.data.result.profile_image;
        this.id = response.data.result.id;
        this.user = { id, first_name, last_name, email, status };
        this.full_name = this.user.first_name + " " + this.user.last_name;
      });
    },
    updateActiveTab() {
      if (String(this.$route.query.isWalletHistory) === "true") {
        this.activeTab = "wallet";
      } else {
        this.activeTab = "profile";
      }
    },
  },
  watch: {
    "$route.query.isWalletHistory": "updateActiveTab",
  },
  mounted() {
    this.getUserDetail();
    this.updateActiveTab();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">
                {{ this.full_name }}
              </h4>
              <p>
                <router-link :to="{ name: 'user-list' }">User Management</router-link>
                {{ this.full_name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Profile</span>
                </template>
                <UserEdit />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Charger</span>
                </template>
                <UserCharger />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Vehicle</span>
                </template>
                <UserVehicle />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Booking</span>
                </template>
                <UserBooking />
              </b-tab>
              <b-tab :active="isWalletHistory">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Wallet Transactions</span>
                </template>
                <UserWalletTransaction />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.page-title-box {
  padding-bottom: 24px;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px !important;
}
.icon-main-page .page-title-left {
  display: flex;
  align-items: center;
}
.avatar-main-icon .avatar-xs {
  margin-top: -20px;
}
</style>
